import { Phone } from 'lucide-react'
import { ChannelAccountsPanel } from '../../components/ChannelAccountsPanel'
import { PageHeader } from '../../components/PageHeader'
import { SociedadScope } from '../../components/SociedadPicker'

export function ChannelAccountsPage() {
  return (
    <div className="flex flex-col gap-6">
      <PageHeader icon={Phone} title="Números de WhatsApp" description="Los canales conectados a esta Sociedad." />
      <SociedadScope>{(sociedadId) => <ChannelAccountsPanel activeSociedadId={sociedadId} />}</SociedadScope>
    </div>
  )
}
